<template>
  <v-dialog v-model="dialogModel" :width="dialogWidth" :fullscreen="isMobile" persistent
    class="video-editor-dialog">
    <NewHeader v-if="isMobile" class="dialog-header"></NewHeader>
    <div class="dialog-container">
     
      <div class="dialog-content">
        <VideoEditor v-if="dialogModel" ref="videoEditor" :video-file="videoFile" @close="handleClose"
          @confirm-trim-end="handleConfirmTrimEnd" />
      </div>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import NewHeader from '@/components/NewHeader.vue'
import VideoEditor from '@/components/VideoEditor/VideoEditor.vue'
import { useDisplay } from 'vuetify'

const props = defineProps<{
  modelValue: boolean // 是否显示对话框
  videoFile: File | null // 视频文件
  showCloseBtn: boolean // 是否显示关闭按钮
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  'confirm-trim-end': [{ start: number, end: number, videoFileUrl: string }],
  'on-close': []
}>()

// 处理 v-model 双向绑定
const dialogModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const videoEditor = ref()

const { mobile } = useDisplay()

const isMobile = computed(() => mobile.value)
const dialogWidth = computed(() => isMobile.value ? '100%' : '1200')


// 处理视频裁剪确认
const handleConfirmTrimEnd = (trimData: { start: number, end: number, videoFileUrl: string }) => {
  // console.log('handleConfirmTrimEnd', trimData);
  dialogModel.value = false
  emit('confirm-trim-end', trimData)
}

const handleClose = () => {
  dialogModel.value = false // 关闭对话框
  emit('on-close')
}
</script>

<style scoped>
.dialog-container {
  display: flex;
  flex-direction: column;
  margin-top: 64px;
  height: calc(100vh - 64px); /* 设置对话框高度为视窗高度的90% */
  max-height: 900px; /* 设置最大高度 */
  /* background: #fff; 确保有背景色 */
}

.dialog-header {
  flex-shrink: 0; /* 防止header被压缩 */
}

.dialog-content {
  flex: 1;
  overflow: hidden; /* 防止内容溢出 */
  margin: 16px;
  border-radius: 16px;
}
</style>